export class ClassificationPolicySchedule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scheduleConfig",
            "baseName": "scheduleConfig",
            "type": "ClassificationScheduleConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ClassificationPolicySchedule.attributeTypeMap;
    }
    constructor() {
    }
}
